import { IconHelpingHand, IconLockOpenOutline, IconPound } from '@iwoca/icons';
import clsx from 'clsx';
import { LayoutHeadings } from 'components/Layout/InnerLayout/LayoutHeadings/LayoutHeadings';
import { ComparisonTable } from '../../ComparisonTable/ComparisonTable';
import { FeatureHighlight } from '../../FeatureHighlight/FeatureHighlight';
import sharedStyles from '../../Products.module.css';
import { ExportToPDFButton } from '../ExportToPDFButton/ExportToPDFButton';
import { UnlockFlexiLoanButton } from '../UnlockFlexiLoanButton/UnlockFlexiLoanButton';
import { useFlexiLoanFeaturesTable } from './FlexiLoanFeatures.helpers';
import styles from './FlexiLoanFeatures.module.css';

export const FlexiLoanFeatures = () => {
  const { data, labels, preferredCommissionRateMessage } =
    useFlexiLoanFeaturesTable();

  return (
    <div className={clsx(sharedStyles.section, styles.container)}>
      <ExportToPDFButton />

      <LayoutHeadings
        heading="Flexi-Loan features"
        headingVariant="long"
        headingAlignment="center"
      />

      <div className={sharedStyles.highlights}>
        <FeatureHighlight icon={IconPound} feature="Loans up to £1 million" />
        <FeatureHighlight icon={IconLockOpenOutline} feature="Unsecured" />
        <FeatureHighlight
          icon={IconHelpingHand}
          feature="Overpay or settle at any time with no additional cost"
        />
      </div>

      <div className={styles.tableWrapper}>
        <ComparisonTable data={data} labels={labels} />
      </div>

      {preferredCommissionRateMessage && (
        <p className={styles.preferredCommissionRate}>
          {preferredCommissionRateMessage}
        </p>
      )}

      <UnlockFlexiLoanButton />
    </div>
  );
};
